<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="">
      <!-- <v-row> -->
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="success"
          @click="$router.go(-1)"
        >
          <v-icon dark>
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
        <br /><br />
        <div
          class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary--text"
        >
          {{ title }}
        </div>
        <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
          <v-alert prominent type="info">
            IMPORTANTE! Los Trámites con Asterisco (*) tienen costo.
          </v-alert>
        </v-col>

        <v-row align="center">
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <label>Trámite</label>
            <v-select
              v-model="tramite"
              :items="tramites"
              item-text="text"
              item-value="value"
              label="Selecciona el trámite"
              persistent-hint
              return-object
              single-line
            ></v-select>
          </v-col>
          <!--
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <label>Sede del trámite</label>
            <v-select
              v-model="sede"
              :items="sedes"
              item-text="text"
              item-value="value"
              label="Selecciona la sede"
              persistent-hint
              return-object
              single-line
            ></v-select>
          </v-col>
          -->
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <label>¿A quién va dirigido?</label>
            <v-text-field
              v-model="person"
              :rules="personRules"
              :counter="10"
              label="Escriba únicamente el nombre de la institución o empresa. Si coloca otra cosa su constancia será cancelada"
              required
            ></v-text-field>
          </v-col>

          <!--
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <label>Urgencia</label>
            <v-select
              v-model="urgencia"
              :items="urgencias"
              item-text="text"
              item-value="value"
              label="Selecciona la urgencia"
              persistent-hint
              return-object
              single-line
            ></v-select>
          </v-col>
          -->
        </v-row>

        <v-row align="center">
          <v-col cols="12" xs="12" sm="12" md="2" lg="6" xl="6">
            <v-btn
              color="success"
              elevation="7"
              large
              v-on:click="examen = true"
              @click="addTramite()"
              >Guardar</v-btn
            >
          </v-col>
        </v-row>
        <div>
          <br />
          <h2>
            Mis trámites
          </h2>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Urgencia
                  </th>
                  <th class="text-left">
                    Estado
                  </th>
                  <th class="text-left">
                    Trámite
                  </th>
                  <th>
                    Url
                  </th>
                  <th>
                    Fecha Solicitud
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(tramiteUserData, tramitesUserKey) in tramitesUser"
                  :key="tramitesUserKey"
                >
                  <td>{{ tramiteUserData.Urgencia }}</td>
                  <td>
                    <div
                      v-if="
                        tramiteUserData.Estado == 'Cancelado' &&
                          tramiteUserData.motivo != null
                      "
                    >
                      <v-btn
                        color="primary"
                        dark
                        @click="motivoRechazoTramite(tramiteUserData.motivo)"
                      >
                        Motivo del Rechazo
                      </v-btn>
                    </div>
                    <div v-else>
                      {{ tramiteUserData.Estado }}
                    </div>
                  </td>
                  <td>
                    {{
                      tramiteUserData.tramite
                        ? tramiteUserData.tramite.Feriado
                        : ""
                    }}
                  </td>
                  <td
                    v-if="
                      tramiteUserData.url &&
                        hoy >= tramiteUserData.dias_expiracion
                    "
                  >
                    <a
                      :href="tramiteUserData.url"
                      class="btn btn-success"
                      target="_blank"
                      >ver constancia</a
                    >
                  </td>
                  <td v-else></td>
                  <td>{{ tramiteUserData.FechaRegistro }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-col>

      <v-dialog v-model="motivoRechazo" max-width="290">
        <v-card>
          <v-card-title class="text-h5">
            Motivo del Rechazo
          </v-card-title>

          <v-card-text>
            {{ mensajeRechazo }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="green darken-1" text @click="motivoRechazo = false">
              Cerrar
            </v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- </v-row> -->
    </CardIeaAppMain>
  </div>
</template>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";
import moment from "moment";

export default {
  name: "MateriaCodigoClaseVideo",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
  },

  data: () => ({
    hoy: moment(new Date()).format("YYYY-MM-DD"),
    title: "Nuevo trámite",
    tramite: { text: "", value: "" },
    sede: { text: "", value: "" },
    urgencia: { text: "Normal", value: "Normal" },
    select: {},
    urgencias: [
      { text: "Normal", value: "Normal" },
      { text: "Media", value: "Media" },
      { text: "Alta", value: "Alta" },
    ],
    tramites: [],
    tramitesUser: [],
    sedes: [],
    person: "",
    personRules: [(v) => !!v || "Campo obligatorio"],
    motivoRechazo: false,
    mensajeRechazo: "",
  }),

  methods: {
    async addTramite() {
      // base de datos aceptado feedback
      let tramite = this.tramite.value;
      let sede = this.sede.value;
      let urgencia = this.urgencia.value;

      let dataSend = {
        process: tramite,
        sede: sede,
        emergency: urgencia,
        person: this.person,
      };

      let url = "alumno-tramite/store";
      await this.$API
        .post({
          url: url,
          data: dataSend,
        })
        .then(() => {
          this.loadTramites();
        });
    },
    async loadTramites() {
      let url = "alumno-tramites";
      await this.$API
        .get({
          url: url,
        })
        .then((res) => {
          this.tramitesUser = res;
        });
    },

    motivoRechazoTramite(motivo) {
      this.mensajeRechazo = motivo;
      this.motivoRechazo = true;
    },
  },

  mounted() {
    this.motivoRechazo = false;
    if (
      this.$store.getters.user.borrado == 1 ||
      this.$store.getters.user.alumno_mora == true
    ) {
      this.$router.push({
        name: "Home",
      });
    }
    console.log(this.hoy);
    this.idTest = this.$route.params.test;
    this.$API
      .get({
        url: "tramites",
        data: {},
      })
      .then((res) => {
        this.tramites = res;
      })
      .catch((err) => {
        console.log(err);
      });
    this.$API
      .get({
        url: "sedes",
        data: {},
      })
      .then((res) => {
        this.sedes = res;
      })
      .catch((err) => {
        console.log(err);
      });
    this.$API
      .get({
        url: "alumno-tramites",
      })
      .then((res) => {
        this.tramitesUser = res;
      });
  },
};
</script>
